import { useQuery } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"
import { useDevAuth } from "@/hooks/use-dev-auth"

import { fetchBackOffice, fetchBackOffices } from "./api"

export function useFetchBackOffices() {
  const getContext = useApiContext()
  const { isLoaded, isSignedIn, userId } = useDevAuth()

  const query = useQuery({
    queryKey: ["back-offices", userId],
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return fetchBackOffices(context)
    },
    enabled: isLoaded && Boolean(isSignedIn),
    staleTime: 5 * 60 * 1000,
    retry: false,
  })
  return query
}

export function useFetchBackOffice(id: string) {
  const getContext = useApiContext()
  const { isLoaded, isSignedIn } = useDevAuth()

  const query = useQuery({
    queryKey: ["back-office", id],
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return fetchBackOffice(context, id)
    },
    enabled: !!id && isLoaded && Boolean(isSignedIn),
    retry: false,
  })
  return query
}
